export type BadgeColorScheme = {
  background: string;
  border: string;
  color: string;
  iconColor: string;
};

export const badgeColors = [
  "success",
  "info",
  "warning",
  "error",
  "gray",
] as const;

export type BadgeColor = "success" | "info" | "warning" | "error" | "gray";

export const badgeColorSchemes: Record<BadgeColor, BadgeColorScheme> = {
  success: {
    background: "bg-success-primary",
    border: "border-success-subtle",
    color: "fg-success-primary",
    iconColor: "text-success-primary",
  },
  warning: {
    background: "bg-warning-primary",
    border: "border-warning-subtle",
    color: "fg-warning-primary",
    iconColor: "text-warning-primary",
  },
  info: {
    background: "bg-info-primary",
    border: "border-info-subtle",
    color: "fg-info-primary",
    iconColor: "text-utility-blue-light-500",
  },
  error: {
    background: "bg-error-primary",
    border: "border-error-subtle",
    color: "fg-error-primary",
    iconColor: "text-error-primary",
  },
  gray: {
    background: "bg-gray-50",
    border: "border-gray-200",
    color: "text-secondary",
    iconColor: "text-quaternary",
  },
};
